// extracted by mini-css-extract-plugin
export var actionIcon = "_mr-0";